import { HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useState } from 'react';
import { Pressable } from 'react-native';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { getCodedColor, tableHeaders } from '../../constants';

interface TransactionItemTypes {
  transaction: any;
  onSelectClient?: (cpfCnpj: string) => void;
}
export const TransactionItem: React.FC<TransactionItemTypes> = ({
  transaction,
  onSelectClient,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getFlex = (index: number) => {
    const currentHead = tableHeaders.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent
      direction="column"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <HStack
        w="full"
        alignItems="center"
        onPress={() => onSelectClient?.(transaction?.clientDocument)}>
        <TableContentItemColumn flex={getFlex(0)}>
          <TableContentItemText>{transaction?.requestDate}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <TableContentItemText>{transaction?.settlementDate}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <Pressable
            onHoverIn={() => setIsHovered(true)}
            onHoverOut={() => setIsHovered(false)}
            onPress={() => onSelectClient?.(transaction?.clientDocument)}>
            {isHovered ? (
              <TableContentItemText color="brand.tertiary.principal">
                {transaction?.clientName}
              </TableContentItemText>
            ) : (
              <TableContentItemText>{transaction?.clientName}</TableContentItemText>
            )}
          </Pressable>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TableContentItemText>{transaction?.product}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <TableContentItemText>{transaction?.type}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <TableContentItemText color={getCodedColor(transaction?.value)}>
            {Utils.Mask.Money(transaction?.value)}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <TableContentItemText>{transaction?.asset}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(7)}>
          <TableContentItemText>{transaction?.status}</TableContentItemText>
        </TableContentItemColumn>
      </HStack>
    </TableContent>
  );
};
